module.exports = __webpack_public_path__ + "img/1440.9eda2f84.jpg";